'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.events = exports.EVENT_BADGE_VISIBILITYCHANGED = exports.EVENT_BADGE_COUNTCHANGED = exports.EVENT_MENU_VISIBILITYCHANGED = exports.EVENT_UI_DISPLAYCHANGED = exports.EVENT_UI_BEFOREDISPLAYCHANGED = exports.EVENT_UI_VISIBILITYCHANGED = exports.EVENT_UI_BEFOREVISIBILITYCHANGED = exports.EVENT_UI_STATECHANGED = exports.EVENT_SETTINGS_VISIBILITYCHANGED = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module UI/events
 */

/**
 * @type {string}
 */
var EVENT_SETTINGS_VISIBILITYCHANGED = exports.EVENT_SETTINGS_VISIBILITYCHANGED = 'ui.show-settings';

/**
 * @type {string}
 */
var EVENT_UI_STATECHANGED = exports.EVENT_UI_STATECHANGED = 'ui.state-transition';

/**
 * @type {string}
 */
var EVENT_UI_BEFOREVISIBILITYCHANGED = exports.EVENT_UI_BEFOREVISIBILITYCHANGED = 'ui.before-visibility-change';

/**
 * @type {string}
 */
var EVENT_UI_VISIBILITYCHANGED = exports.EVENT_UI_VISIBILITYCHANGED = 'ui.visibility-change';

/**
 * @type {string}
 */
var EVENT_UI_BEFOREDISPLAYCHANGED = exports.EVENT_UI_BEFOREDISPLAYCHANGED = 'ui.before-display-change';

/**
 * @type {string}
 */
var EVENT_UI_DISPLAYCHANGED = exports.EVENT_UI_DISPLAYCHANGED = 'ui.display-change';

/**
 * @type {string}
 */
var EVENT_MENU_VISIBILITYCHANGED = exports.EVENT_MENU_VISIBILITYCHANGED = 'ui.menu-change';

/**
 * @type {string}
 */
var EVENT_BADGE_COUNTCHANGED = exports.EVENT_BADGE_COUNTCHANGED = 'ui.badge_count-changed';

/**
 * @type {string}
 */
var EVENT_BADGE_VISIBILITYCHANGED = exports.EVENT_BADGE_VISIBILITYCHANGED = 'ui.badge_visibility-changed';

/**
 * @readonly
 * @enum {string}
 * @type {{EVENT_UI_STATECHANGED: string, EVENT_UI_BEFOREDISPLAYCHANGED: string, EVENT_UI_DISPLAYCHANGED: string, EVENT_UI_BEFOREVISIBILITYCHANGED: string, EVENT_UI_VISIBILITYCHANGED: string, EVENT_SETTINGS_VISIBILITYCHANGED: string, EVENT_MENU_VISIBILITYCHANGED: string, EVENT_BADGE_COUNTCHANGED: string, EVENT_BADGE_VISIBILITYCHANGED: string}}
 */
var events = exports.events = {
  EVENT_UI_STATECHANGED: EVENT_UI_STATECHANGED,
  EVENT_UI_BEFOREDISPLAYCHANGED: EVENT_UI_BEFOREDISPLAYCHANGED,
  EVENT_UI_DISPLAYCHANGED: EVENT_UI_DISPLAYCHANGED,
  EVENT_UI_BEFOREVISIBILITYCHANGED: EVENT_UI_BEFOREVISIBILITYCHANGED,
  EVENT_UI_VISIBILITYCHANGED: EVENT_UI_VISIBILITYCHANGED,

  EVENT_SETTINGS_VISIBILITYCHANGED: EVENT_SETTINGS_VISIBILITYCHANGED,
  EVENT_MENU_VISIBILITYCHANGED: EVENT_MENU_VISIBILITYCHANGED,

  EVENT_BADGE_COUNTCHANGED: EVENT_BADGE_COUNTCHANGED,
  EVENT_BADGE_VISIBILITYCHANGED: EVENT_BADGE_VISIBILITYCHANGED
};

/**
 * @readonly
 * @type {Array}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 * @param {String} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/UI/events.js
// module id = 166
// module chunks = 0